export const ActionTypes = {
  GET_CASINO_GAMES_REQUEST: '[CASINO GAMES] GET CASINO GAMES REQUEST',
  GET_CASINO_GAMES_SUCCESS: '[CASINO GAMES] GET CASINO GAMES SUCCESS',
  GET_CASINO_GAMES_FAILURE: '[CASINO GAMES] GET CASINO GAMES FAILURE',
};

export class Actions {
  static getCasinoGamesRequest() {
    return {
      type: ActionTypes.GET_CASINO_GAMES_REQUEST
    };
  }

  static getCasinoGamesSuccess(items) {
    return {
      type: ActionTypes.GET_CASINO_GAMES_SUCCESS,
      games: items
    };
  }

  static getCasinoGamesFailure() {
    return {
      type: ActionTypes.GET_CASINO_GAMES_FAILURE
    };
  }
}
